module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading/heading_6-790780ccc7b8e0455469d48ed5ca192f.png";